module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    ref: "info-window"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.imovel.id
        }
      }
    }
  }, [_c('v-card-title', {
    staticClass: "pb-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', {
    staticClass: "subheading",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.infoWindowContentApelido))])]), _vm._v(" "), (_vm.infoWindowContentProprietario.length > 0) ? _c('div', {
    staticClass: "grey--text text--darken-2",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(_vm._s(_vm.infoWindowContentProprietario))]) : _vm._e()]), _vm._v(" "), (_vm.infoWindowContentFoto.length > 0) ? _c('v-card-media', {
    staticClass: "mb-3",
    attrs: {
      "src": _vm.infoWindowContentFoto,
      "height": "170px"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0 pb-4"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "grey--text text--darken-2"
  }, [_vm._v(_vm._s(_vm.infoWindowContentEndereco))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "info-coluna",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.infoWindowContentVistoria) ? _c('ListaVistoriaSituacao', {
    attrs: {
      "situacao": _vm.infoWindowContentVistoria
    }
  }) : _c('v-btn', {
    staticClass: "secondary secondary--text ma-0 caption",
    attrs: {
      "outline": "",
      "block": ""
    }
  }, [_vm._v("Sem vistoria")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "info-coluna",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey grey--text ma-0 caption",
    attrs: {
      "outline": "",
      "block": ""
    }
  }, [(_vm.infoWindowContentTarefasPendentes === 1) ? [_c('span', {
    staticClass: "headline"
  }, [_vm._v("1  ")]), _vm._v("tarefa")] : (_vm.infoWindowContentTarefasPendentes > 1) ? [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.infoWindowContentTarefasPendentes) + "  ")]), _vm._v("tarefas")] : [_vm._v("Sem tarefas")]], 2)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18b07ed6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imoveis/Mapa/MapaInfoWindow.vue
// module id = 990
// module chunks = 1